<!-- =========================================================================================
	File Name: App.vue
	Description: Main vue file - APP
	----------------------------------------------------------------------------------------
	Item Name: Vuesax Admin - VueJS Dashboard Admin Template
	Author: Pixinvent
	Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
	<div id="app">
		<router-view></router-view>
	</div>
</template>

<script>
import themeConfig from '@/../themeConfig.js'
import api from './request/api'
export default {
  watch: {
    '$store.state.theme'(val) {
      this.toggleClassInBody(val);
    }
  },
  async created() {
  //   try {
	 //  await api.getuserinfo({}).then(res=>{  //获取当前登录用户信息
	 //  	console.log("当前用户：",res);
		// this.$store.dispatch('getUserinfo',res.data);
	 //  })
  //   } catch (e) {
  //     console.log(e);
  //   }
  },
  methods: {
    toggleClassInBody(className) {
      if (className == 'dark') {
        if (document.body.className.match('theme-semi-dark')) document.body.classList.remove('theme-semi-dark');
        document.body.classList.add('theme-dark');
      } else if (className == 'semi-dark') {
        if (document.body.className.match('theme-dark')) document.body.classList.remove('theme-dark');
        document.body.classList.add('theme-semi-dark');
      } else {
        if (document.body.className.match('theme-dark')) document.body.classList.remove('theme-dark');
        if (document.body.className.match('theme-semi-dark')) document.body.classList.remove('theme-semi-dark');
      }
    },
    handleWindowResize(event) {
      this.$store.dispatch('updateWindowWidth', event.currentTarget.innerWidth);
    },
  },
  mounted() {
	 //看板娘
	 // setTimeout(() => {
	 //       window.L2Dwidget.init({
	 //           pluginRootPath: 'live2dw/',
	 //           pluginJsPath: 'lib/',
	 //           pluginModelPath: 'live2d-widget-model-tororo/assets/',
	 //           tagMode: false,
	 //           debug: false,
	 //           model: { jsonPath: '../live2dw/live2d-widget-model-tororo/assets/tororo.model.json' },
	 //           display: { position: 'right', width: 220, height: 240,"hOffset": 50,"vOffset": 50 },
	 //           mobile: { show: false },
	 //           log: false
	 //           })
	 // }, 1000) 
	
    this.toggleClassInBody(themeConfig.theme)
    this.$nextTick(() => {
      window.addEventListener('resize', this.handleWindowResize);
    });
    this.$store.dispatch('updateWindowWidth', window.innerWidth);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleWindowResize);
  },
}

</script>
